import PropTypes from 'prop-types';
import _ from 'lodash';
import React from 'react';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import FilterBar from '../FilterBar';

function getColumns(setSort, sortConfig) {
  return [
    {
      label: 'Client Name',
      sortColumn: 'person.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service.name',
    },
    {
      label: 'Last Updated',
      sortColumn: 'updated_at',
      type: 'date',
      ...(setSort && sortConfig && {
        sortBy: setSort?.sidx,
        sortDirection: setSort?.sord,
        setSort: ({ sortBy, sortDirection }) => sortConfig(sortBy, sortDirection),
      }),
    },
  ];
}

export function DraftReferralsIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    filters,
    onFiltersChange,
    fetchGroupsUsers,
    sortConfig,
    setSort,
  } = props;
  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Draft referrals"
                id="draft-referrals-table"
                dataSet={data}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(setSort, sortConfig)}
                emptyMessage="There are no draft referrals."
                rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
              />
            )
        }
      </div>
    </div>
  );
}

DraftReferralsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  fetchGroupsUsers: PropTypes.func.isRequired,

  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
};

DraftReferralsIndex.defaultProps = {
  sortConfig: null,
  setSort: null,
};

export default DraftReferralsIndex;
